module.exports = __webpack_public_path__ + "static/media/icon-inbox-white.72ecb0b9.svg";